import React from 'react';
import * as S from './Button.styled';
import { LoadingIndicator } from 'components/LoadingIndicator';

export const Button = ({ text, onClick = () => {}, disabled, isSmall, isOutlined, isLoading, className }) => (
  <S.Wrapper onClick={onClick} className={className} disabled={disabled || isLoading} isSmall={isSmall} isOutlined={isOutlined}>
    {isLoading ? <LoadingIndicator highlight={!!isOutlined} /> : text}
  </S.Wrapper>
);
